import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from '@chakra-ui/react';
import { appEnv } from '@izimi/core';
export const UnsupportedNotification = ({ type, }) => {
    return appEnv === 'development' ?
        (_jsx(Box, { bg: 'green', my: 1, p: 4, children: _jsxs(Text, { color: 'white', children: ["Missing type:", type] }) })) :
        null;
};
